import type IntlService from 'ember-intl/services/intl';
import type { TourConfig } from 'tio-common/services/tour-manager';

/**
 * The tour pointing at the relocated Advanced Filters button. The popover copy is
 * translated with the caller's current locale when the tour is built.
 */
function advancedFiltersMovedTour(intl: IntlService): TourConfig {
  return {
    id: 'advanced-filters-moved',
    name: 'Advanced Filters Location',
    steps: [
      {
        element: '[data-tour="advanced-filters-button"]',
        popover: {
          title: intl.t('common.reporting.tours.advanced_filters_moved.title'),
          description: intl.t('common.reporting.tours.advanced_filters_moved.description'),
          side: 'left',
          align: 'start',
        },
      },
    ],
    driverOptions: {
      showProgress: false,
      showButtons: ['close'],
    },
  };
}

export { advancedFiltersMovedTour };
